/**
 *
 * @param {string} newSelectedYear Newly selected year
 * @param {function} isMostRecentYearSetter Setter function for isMostRecentYear state
 * @param {function} selectedYearSetter Setter function for selected year
 * @param {Object} dateOptions Object with date options
 */
export const handleYearChange = (
  newSelectedYear,
  isMostRecentYearSetter,
  selectedYearSetter,
  dateOptions
) => {
  if (
    newSelectedYear === "HIST" ||
    newSelectedYear === dateOptions.mostRecentDate.year
  )
    isMostRecentYearSetter(true);
  else isMostRecentYearSetter(false);

  selectedYearSetter(newSelectedYear);
};
